import { z } from 'zod';

/** `PATCH /api/workspace` body (workspace-first shell spec, 2026-08-21). Trimmed before the
 * length check so "  A  " is a 1-char name, not a 5-char one. */
export const workspaceRenameSchema = z.object({
  name: z.string().trim().min(2).max(60),
});

export type WorkspaceRenameInput = z.infer<typeof workspaceRenameSchema>;
